import script from "./toolbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./toolbox.vue?vue&type=script&setup=true&lang=ts"

import "./toolbox.vue?vue&type=style&index=0&id=d4ad589a&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4ad589a"]])

export default __exports__